import { createRouteRef, createApiRef, createPlugin, createApiFactory, configApiRef, createRoutableExtension } from '@backstage/core-plugin-api';
import { Spectral } from '@stoplight/spectral-core';
import { bundleAndLoadRuleset } from '@stoplight/spectral-ruleset-bundler/with-loader';
import { fetch } from '@stoplight/spectral-runtime';

const ANNOTATION_SPECTRAL_RULESET_URL = "backstage.io/spectral-ruleset-url";
const getSpectralRulesetUrl = (entity) => {
  var _a, _b;
  return (_b = (_a = entity.metadata.annotations) == null ? void 0 : _a[ANNOTATION_SPECTRAL_RULESET_URL]) == null ? void 0 : _b.trim();
};
const isApiDocsSpectralLinterAvailable = (entity) => {
  var _a, _b;
  return Boolean(entity.kind === "API") && Boolean(((_a = entity.spec) == null ? void 0 : _a.type) === "openapi" || ((_b = entity.spec) == null ? void 0 : _b.type) === "asyncapi");
};

const rootRouteRef = createRouteRef({
  id: "api-docs-spectral-linter"
});

class LinterClient {
  constructor(options) {
    this.configApi = options.configApi;
  }
  async lintApi(content, flavor, ruleSetUrl) {
    let ruleSetToDownload = ruleSetUrl;
    if (!ruleSetToDownload) {
      ruleSetToDownload = this.configApi.getOptionalString(
        `spectralLinter.${flavor === "openapi" ? "openApiRulesetUrl" : "asyncApiRulesetUrl"}`
      );
    }
    if (!ruleSetToDownload) {
      throw new Error(
        `Missing rule set, you can provide a rule set with annotation ${ANNOTATION_SPECTRAL_RULESET_URL}`
      );
    }
    const fs = {
      promises: {
        async readFile(filepath) {
          if (filepath === "/.spectral.yaml") {
            return `
            extends:
            - ${ruleSetToDownload}
            `;
          }
          throw new Error(`Could not read ${filepath}`);
        }
      }
    };
    const spectral = new Spectral();
    const ruleSet = await bundleAndLoadRuleset("/.spectral.yaml", {
      fs,
      fetch
    });
    spectral.setRuleset(ruleSet);
    const spectralResult = await spectral.run(content);
    return {
      rulesetUrl: ruleSetToDownload,
      data: spectralResult.sort((a, b) => a.severity - b.severity).map((diagnosticItem) => ({
        linePosition: {
          start: diagnosticItem.range.start.line,
          end: diagnosticItem.range.end.line
        },
        message: diagnosticItem.message,
        severity: diagnosticItem.severity,
        path: diagnosticItem.path.map((item) => item.toString()),
        code: diagnosticItem.code
      }))
    };
  }
  async lint({ entity }) {
    if (!this.isApiTypeSupported(entity)) {
      throw new Error(
        `Linting is not supported for spec.type=${entity.spec.type}.`
      );
    }
    return this.lintApi(
      entity.spec.definition,
      entity.spec.type,
      getSpectralRulesetUrl(entity)
    );
  }
  isApiTypeSupported(entity) {
    return isApiDocsSpectralLinterAvailable(entity);
  }
}

const linterApiRef = createApiRef({
  id: "plugin.spectral.linter.api"
});

const apiDocsSpectralLinterPlugin = createPlugin({
  id: "api-docs-spectral-linter",
  apis: [
    createApiFactory({
      api: linterApiRef,
      deps: {
        configApi: configApiRef
      },
      factory({ configApi }) {
        return new LinterClient({ configApi });
      }
    })
  ],
  routes: {
    root: rootRouteRef
  }
});
const EntityApiDocsSpectralLinterContent = apiDocsSpectralLinterPlugin.provide(
  createRoutableExtension({
    name: "EntityApiDocsSpectralLinterPluginContent",
    component: () => import('./index-414e346b.esm.js').then(
      (m) => m.EntityApiDocsSpectralLinterContent
    ),
    mountPoint: rootRouteRef
  })
);

export { EntityApiDocsSpectralLinterContent as E, apiDocsSpectralLinterPlugin as a, isApiDocsSpectralLinterAvailable as i, linterApiRef as l };
//# sourceMappingURL=index-baae3195.esm.js.map
